module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-minus-4f076aa2cca927d806a77e7a8468d568.svg";